interface ProgramGameModalFieldErrorProps {
	show: boolean;
	message?: string;
}

export function ProgramGameModalFieldError({ show, message }: ProgramGameModalFieldErrorProps) {
	if (!show || message === undefined) {
		return null;
	}

	return <p className="discoverGamesProgramModal-error">{message}</p>;
}
